<template>
    <div>
        <v-toolbar v-if="$route.query.mode != 'headless'" dark class="primary text-xl-center">
            <v-toolbar-title style="width:100%">
              <img src="/static/images/logo_negative.png" style="  height: 90%;position: absolute; right: 0; top: 2px;">
                {{$store.state.rechnerConfig.rechnerInfo.label}}
            </v-toolbar-title>

        </v-toolbar>
        <div v-if="$store.state.rechnerStatus =='Antrag: submit successed'">
            <br>Ihr Antrag wurde erfolgreich abgeschickt.
            <br>Wir werden diesen zeitnah bearbeiten.
            <br>Die Versicherungsunterlagen werden Ihnen in Kürze auf dem postalischen Weg zugesandt.

        </div>
        <div v-if="$store.state.rechnerConfig.rechnerInfo.active==1 && $store.state.rechnerConfig.loaded==true && $store.state.rechnerStatus !='Antrag: submit successed'">
            <component :is="'Rechner_'+$store.state.rechnerConfig.rechnerInfo.name">
            </component>

        </div>
        <div v-if="$store.state.rechnerConfig.rechnerInfo.active==0">
            <br><br><br><br><br>
            Da wir unser Angebot im Moment für Sie überarbeiten,
            steht dieser Rechner zur Zeit nicht zur Verfügung,
            <br>
        </div>
    </div>
</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>
    import Rechner_wohngebaeude from './wohngebaeude/Rechner_wohngebaeude'
    import Rechner_fahrrad from './fahrrad/Rechner_fahrrad'
    import Rechner_glasbruch from './glasbruch/Rechner_glasbruch'
    import Rechner_hausrat from './hausrat/Rechner_hausrat'
    import Rechner_unfall_e from './unfall_e/Rechner_unfall_e'
    import Rechner_unfall_r from './unfall_r/Rechner_unfall_r'
    import Rechner_seniorenunfall from './seniorenunfall/Rechner_seniorenunfall'
    import Rechner_reifen from './reifen/Rechner_reifen'
    import Rechner_heizung from './heizung/Rechner_heizung'
    import Rechner_thhund from './thhund/Rechner_thhund'
    import Rechner_thpferd from './thpferd/Rechner_thpferd'
    import Rechner_privat from './privat/Rechner_privat'
    import Rechner_rechtschutz from './rechtschutz/Rechner_rechtschutz'
    import Rechner_gewaesser from './gewaesser/Rechner_gewaesser'
    import Rechner_hausgrund from './hausgrund/Rechner_hausgrund'
    import Rechner_bauherren from './bauherren/Rechner_bauherren'

    export default {
        //========================================================================================================
        name: 'Rechner-Page',
        //========================================================================================================
        components: {
            Rechner_seniorenunfall,
            Rechner_unfall_e,
            Rechner_unfall_r,
            Rechner_hausrat,
            Rechner_glasbruch,
            Rechner_wohngebaeude,
            Rechner_fahrrad,
            Rechner_reifen,
            Rechner_heizung,
            Rechner_thhund,
            Rechner_thpferd,
            Rechner_privat,
            Rechner_rechtschutz,
            Rechner_gewaesser,
            Rechner_hausgrund,
            Rechner_bauherren
        },
        //========================================================================================================
        beforeCreate: function () {
            var rechnerName = this.$route.params.rechnerName === undefined ? '' : this.$route.params.rechnerName
            var vermittlerNr = this.$route.params.vermittlerNr === undefined ? '' : this.$route.params.vermittlerNr
            var tarif_gruppe = 'tarif_' + (typeof this.$route.query.tarifgruppe === "undefined" ? 'n' : this.$route.query.tarifgruppe)
            var tarif_filter = (typeof this.$route.query.tariffilter === "undefined" ? 'freizeit' : this.$route.query.tariffilter)
            this.$store.dispatch(
                'sendApiRequest',
                {
                    sender: 'RechnerTemplate->created',
                    command: 'getRechnerConfig',
                    args: {
                        url_param_rechner: rechnerName,
                        url_param_vermittler: vermittlerNr,
                        url_param_tarifgruppe: tarif_gruppe,
                        url_param_tariffilter: tarif_filter,
                    },

                    onSuccess: (response) => {

                        /* ALTE VERSION: HF/UV-Mode & HV/UV-Label über URL-Query: */
                        /*
                         //anhand der URL-Paramter/Situation die Labels für Haupt-/Unter-Vermittler bestimmt/angepasst:
                         if (!(this.$route.query.uvr_mode > '')) {
                             response.data.rechnerConfig.fieldDefs.abschluss_UnterVermittler_nr.validate = ''

                         }
                         if (this.$route.query.uvr_mode > '') {
                             response.data.rechnerConfig.fieldDefs.abschluss_Vermittler_nr.label = "Haupt-Vermittler-Nr";
                             response.data.rechnerConfig.fieldDefs.abschluss_VermVollmacht_vorhanden.label = "Haupt-Vermittler-Nr & Makler-Vollmacht vorhanden?";


                         }
                         if (this.$route.query.hv_mode == 'hidden') {
                             response.data.rechnerConfig.fieldDefs.abschluss_UnterVermittler_nr.label = "Vermittler-Nr";
                             response.data.rechnerConfig.fieldDefs.abschluss_UnterVermVollmacht_vorhanden.label = "Vermittler-Nr & Makler-Vollmacht vorhanden?";
                           }


                         if (this.$route.query.hv_label > '') {

                             var newLabel=this.$route.query.hv_label.replace(/(<([^>]+)>)/gi, "")
                             response.data.rechnerConfig.fieldDefs.abschluss_Vermittler_nr.label = newLabel
                             var  oldLabel=  response.data.rechnerConfig.fieldDefs.abschluss_VermVollmacht_vorhanden.label
                             newLabel = oldLabel.replace('Vermittler-Nr',newLabel)
                             response.data.rechnerConfig.fieldDefs.abschluss_VermVollmacht_vorhanden.label = newLabel
                         }
                         if (this.$route.query.uvr_label > '') {
                             var newLabel= this.$route.query.uvr_label.replace(/(<([^>]+)>)/gi, "")
                             response.data.rechnerConfig.fieldDefs.abschluss_UnterVermittler_nr.label = newLabel

                             var  oldLabel= response.data.rechnerConfig.fieldDefs.abschluss_UnterVermVollmacht_vorhanden.label
                             // "replace" muss hier 2x gemacht werden, da 20 Zeilen weiter oben evtl. "Unter-Vermittler-Nr" in "Vermittler-Nr" ersetzt wurde
                             newLabel= oldLabel.replace('Unter-Vermittler-Nr',newLabel).replace('Vermittler-Nr',newLabel)
                             response.data.rechnerConfig.fieldDefs.abschluss_UnterVermVollmacht_vorhanden.label = newLabel
                         }
                     */

                        /* NEUE VERSION: HF/UV-Mode & HV/UV-Label über Datenbank auf dem Server (Daten kommen über get_rechner_Config): */

                        if (!(response.data.rechnerConfig.vermittlerData.UVM > '')) {
                            response.data.rechnerConfig.fieldDefs.abschluss_UnterVermittler_nr.validate = ''

                        }
                        if (response.data.rechnerConfig.vermittlerData.UVM > '') {
                            response.data.rechnerConfig.fieldDefs.abschluss_Vermittler_nr.label = "Haupt-Vermittler-Nr";
                            response.data.rechnerConfig.fieldDefs.abschluss_VermVollmacht_vorhanden.label = "Haupt-Vermittler-Nr & Makler-Vollmacht vorhanden?";


                        }
                        if (response.data.rechnerConfig.vermittlerData.HVM == 'hidden') {
                            response.data.rechnerConfig.fieldDefs.abschluss_UnterVermittler_nr.label = "Vermittler-Nr";
                            response.data.rechnerConfig.fieldDefs.abschluss_UnterVermVollmacht_vorhanden.label = "Vermittler-Nr & Makler-Vollmacht vorhanden?";
                        }


                        if (response.data.rechnerConfig.vermittlerData.HVL > '') {

                            var newLabel = response.data.rechnerConfig.vermittlerData.HVL.replace(/(<([^>]+)>)/gi, "")
                            response.data.rechnerConfig.fieldDefs.abschluss_Vermittler_nr.label = newLabel
                            var oldLabel = response.data.rechnerConfig.fieldDefs.abschluss_VermVollmacht_vorhanden.label
                            newLabel = oldLabel.replace('Vermittler-Nr', newLabel)
                            response.data.rechnerConfig.fieldDefs.abschluss_VermVollmacht_vorhanden.label = newLabel
                        }
                        if (response.data.rechnerConfig.vermittlerData.UVL > '') {
                            var newLabel = response.data.rechnerConfig.vermittlerData.UVL.replace(/(<([^>]+)>)/gi, "")
                            response.data.rechnerConfig.fieldDefs.abschluss_UnterVermittler_nr.label = newLabel

                            var oldLabel = response.data.rechnerConfig.fieldDefs.abschluss_UnterVermVollmacht_vorhanden.label
                            // "replace" muss hier 2x gemacht werden, da 20 Zeilen weiter oben evtl. "Unter-Vermittler-Nr" in "Vermittler-Nr" ersetzt wurde
                            newLabel = oldLabel.replace('Unter-Vermittler-Nr', newLabel).replace('Vermittler-Nr', newLabel)
                            response.data.rechnerConfig.fieldDefs.abschluss_UnterVermVollmacht_vorhanden.label = newLabel
                        }

                        this.$store.commit('set_rechnerConfig', {data: response.data.rechnerConfig})
                        this.$store.commit('set_testDaten', {data: response.data.testDaten})

                    }
                }
            )
        }, //__________________________________________________________________________________________
        created: function () {
            for (var key in this.steps) {
                var step = this.steps[key]

                this.$options.components[step.name] = step.component
            }
        }, //__________________________________________________________________________________________
        mounted: function () {

        }, //__________________________________________________________________________________________
//========================================================================================================
        data: function () {
            return {
                test: 1,
            }
        }, //=====================================================================================================
        computed: {}, //==========================================================================================
        methods: {}, //===========================================================================================

    }
    //¯
    /*
    ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯
    ¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨
    ………………………………………………………………………
    •••••••••••••••••••••••••••
    »»»»»»»»»»»»»»»»»»»»»»»»»»
    ­­­­­­­­­­­­­­­­­­­­­­­­­­
    ———————————————————————————

    –––––––––––––––––––––
    */
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style type="less">
    /*
    .stepper__step {
        min-height: 6.1em;
    }

    .stepper__label span.main-text {
        padding-left: 35px;
        margin-left: -35px;
        cursor: pointer;
        z-index: 1;

    }

    .rechner {

    }

    .rechner-content {
        position: relative;
        width: 100%;
        height: 300px;
        border: 2px solid red;
        overflow: hidden;
    }

    .step {
        width: 100%;
        height: 50%;
        position: absolute;
        left: 0;
        top: 0;
        background: #eeeeee;
        border: solid 3px purple;
    }

    .rechner-footer {
        border: 2px solid blue;

    }

    .fadeIn-enter-active {
        transition: all 1s ease-in;
        opacity: 1;
    }

    .fadeIn-enter

    {

        opacity: 0;
    }

    */
</style>
